// automatically generated by the FlatBuffers compiler, do not modify
/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */
import * as flatbuffers from 'flatbuffers'

import {Id} from './id.js'

export class DuplicateOp {
  bb: flatbuffers.ByteBuffer | null = null
  bb_pos = 0
  __init(i: number, bb: flatbuffers.ByteBuffer): DuplicateOp {
    this.bb_pos = i
    this.bb = bb
    return this
  }

  opId(obj?: Id): Id | null {
    return (obj || new Id()).__init(this.bb_pos, this.bb!)
  }

  originalServerTime(): bigint {
    return this.bb!.readUint64(this.bb_pos + 8)
  }

  duplicateServerTime(): bigint {
    return this.bb!.readUint64(this.bb_pos + 16)
  }

  static sizeOf(): number {
    return 24
  }

  static createDuplicateOp(
    builder: flatbuffers.Builder,
    op_id_site: number,
    op_id_timestamp: number,
    original_server_time: bigint,
    duplicate_server_time: bigint
  ): flatbuffers.Offset {
    builder.prep(8, 24)
    builder.writeInt64(BigInt(duplicate_server_time ?? 0))
    builder.writeInt64(BigInt(original_server_time ?? 0))
    builder.prep(4, 8)
    builder.writeInt32(op_id_timestamp)
    builder.pad(2)
    builder.writeInt16(op_id_site)
    return builder.offset()
  }
}
